import { BOX_STATUS } from "../../../constants/boxing";

const serializationRegex = /^[a-zA-Z0-9]+\s\d+\s\d+$/;
const workOrderRegex = /^[A-Z]{2}-\d+-\d+$/;
const employeeIdRegex = /^[A-Z]{2}\d{4}$/;

export const onBarcodeScanHelper = ({
  barcode = "",
  options = [],
  users = [],
  addworkOrder = () => {},
  setValue = () => {},
}) => {
  const serializationMatch = serializationRegex.test(barcode);
  const workOrderMatch = workOrderRegex.test(barcode);
  const employeeIdMatch = employeeIdRegex.test(barcode);
  
  if (employeeIdMatch) {
    const user = users?.find((u) => u?.employeeId === barcode);
    if (user?.id) setValue("userId", user.id);
    return;
  }

  if (!(serializationMatch || workOrderMatch)) return;

  if (workOrderMatch) {
    const workOrder = options?.find(({ label }) => label === barcode);
    if (workOrder?.id) addworkOrder({ workOrderId: workOrder.id });
    return;
  }

  if (serializationMatch) {
    const [pn, lot] = barcode.split(" ");

    const workOrder = options?.find(({ part, lotNumber }) => {
      const partNumber = part.partNumber;
      const numOnlyLotNumber = lotNumber.replace(/\D/g, "");
      const lotMatch = lot.replace(/^0+/, "") === numOnlyLotNumber;
      const partMatch = pn === partNumber;
      return lotMatch && partMatch;
    });
    if (workOrder?.id) addworkOrder({ workOrderId: workOrder.id, barcode });
  }
};

export const handleBarcodeHelper = ({
  workOrderId,
  barcode = "",
  append = () => {},
  getValues = () => {},
  setValue = () => {},
  options = [],
}) => {
  const workOrder = options?.find((wo) => wo.id === workOrderId);

  if (!workOrder.id) return;

  if (!barcode) {
    return handleAddHelper({
      defaultValues: { workOrderId },
      append,
      getValues,
      setValue,
      options,
    });
  }

  const items = getValues("workOrders");

  const index = items?.findIndex((wo) => wo.workOrderId === workOrderId);
  if (index >= 0) {
    const duplicate = items[index];
    const serialization = duplicate?.serialization ?? [];
    const hasBarcode = serialization.find(({ label }) => label === barcode);

    if (hasBarcode) return;

    const newQuantity = serialization.length + 1;
    setValue(`workOrders.${index}.quantity`, newQuantity);
    setValue(`workOrders.${index}.serialization`, [
      { label: barcode },
      ...serialization,
    ]);

    return;
  }

  const quantity = 1;

  const partWeight = workOrder?.part?.weight || 0;
  const preRound = Number(quantity) * Number(partWeight);
  const weight = Math.round(preRound * 100) / 100;

  const value = {
    workOrderId,
    quantity,
    weight,
    serialization: [{ label: barcode }],
  };
  append(value);

  const boxWeight = getValues("weight") || 0;
  const newBoxWeight = boxWeight + weight;
  const rounded = Math.round(newBoxWeight * 100) / 100;
  setValue("weight", rounded);
};

export const handleAddHelper = ({
  defaultValues = {},
  append = () => {},
  getValues = () => {},
  setValue = () => {},
  options = [],
}) => {
  const id = defaultValues?.workOrderId || null;
  const workOrder = options?.find((wo) => wo.id === id);
  const available = workOrder?.available || 0;

  const items = getValues("workOrders");

  const duplicate = items?.map(({ workOrderId }) => workOrderId).includes(id);
  if (duplicate) return;

  const similar = items?.filter(
    ({ workOrderId, status }) =>
      workOrderId === id && status !== BOX_STATUS.SHIPPED,
  );

  const used = similar?.reduce(
    (tol, { quantity = 0 }) => tol + Number(quantity),
    0,
  );

  const quantity = available - used > 0 ? available - used : 0;

  const partWeight = workOrder?.part?.weight || 0;
  const preRound = Number(quantity) * Number(partWeight);
  const weight = Math.round(preRound * 100) / 100;

  const value = {
    workOrderId: id,
    quantity,
    weight,
    ...defaultValues,
  };
  append(value);

  const boxWeight = getValues("weight") || 0;
  const newBoxWeight = boxWeight + weight;
  const rounded = Math.round(newBoxWeight * 100) / 100;
  setValue("weight", rounded);
};
